import { addDays, startOfMonth } from "date-fns";
import { CongratsSettings, NewModuleSetting, Product, User } from "@models";
import { startDateOnSplit } from "./util";

export default function createDefaultModuleSetting(
	product: Product,
	user: User,
	hasActiveModuleSetting?: boolean,
	divisionCategories?: string[]
): NewModuleSetting {
	const defaultVariant = product.variants[0];

	const availableFrom = hasActiveModuleSetting
		? startDateOnSplit(product.id)
		: startOfMonth(new Date());

	const settings = product.getDefaultSettings();
	const availableUntil =
		product.id === "congrats"
			? addDays(
					availableFrom,
					(settings as CongratsSettings).validTimeInDays - 1
			  )
			: null;

	return {
		availableFrom,
		availableUntil,
		amounts: product.getDefaultAmounts(defaultVariant.id),
		userId: user.userId,
		balanceAccountId: null,
		categories: product.getDefaultCategories(
			defaultVariant.id,
			divisionCategories
		),
		category: product.id,
		productVariantId: defaultVariant.id,
		settings,
		useBalanceAccount: false,
		useExcessBudget: false,
		initialCorrectionAmount: null,
	};
}
